<template>
  <div class="container">
    <div class="top-bg"></div>
    <div class="bind-order-card">
      <div class="info-item">
        <span class="label">雇主手机号</span>
        <input class="value" placeholder="请输入手机号" v-model="phone" maxlength="11" inputmode="numeric" pattern="[0-9]*"
          @input="onPhoneInput" />
      </div>
      <div class="line"></div>
      <div class="info-item">
        <span class="label">服务订单号</span>
        <span class="value gray">{{ orderId }}</span>
      </div>
      <div class="line"></div>
      <div class="info-item">
        <span class="label"><span class="required">*</span>宝宝性别</span>
        <span class="select-trigger" @click="showGenderSheet = true">
          {{ babyGender || '请选择' }}
          <img src="https://hzwimspic-1251601690.image.myqcloud.com/b7ef193c-468e-43b7-a404-07d68cfdcabf_size_15x25"
            alt="">
        </span>
      </div>
    </div>
    <div class="btn-group">
      <button :class="['btn', 'gray']" @click="onQuery" :disabled="!isPhoneValid">查询</button>
      <button class="btn pink" @click="onBind">绑定订单</button>
    </div>
    <van-popup v-model="showGenderSheet" position="bottom">
      <van-picker title="性别选择" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
    </van-popup>
  </div>
</template>

<script>
import { Picker, Popup } from 'vant'
import { getBindOrder, queryYueSaoOrder, saveBindOrder } from '../service'

export default {
  data() {
    return {
      phone: '',
      orderId: '',
      showGenderSheet: false,
      babyGender: '',
      columns: ['男', '女'],
    }
  },
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  created() {
    this.$$title('绑定订单')
    getBindOrder().then((res) => {
      this.$$loading(false)
      if (res?.orderId) {
        this.$router.replace(`/yuesao-serve/log-detail-serve?orderId=${res.orderId}`)
      }
    }).catch((err) => {
      this.orderId = ''
      this.$$loading(false)
    })
  },
  computed: {
    isPhoneValid() {
      const phoneRegex = /^1[3-9]\d{9}$/
      return phoneRegex.test(this.phone)
    }
  },
  methods: {
    onConfirm(value, index) {
      this.babyGender = value
      this.showGenderSheet = false
    },
    onCancel() {
      this.showGenderSheet = false
    },
    onPhoneInput(e) {
      // 只保留数字，最多11位
      let val = e.target.value.replace(/\D/g, '').slice(0, 11)
      this.phone = val
    },
    onQuery() {
      // 手机号格式验证
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!phoneRegex.test(this.phone)) {
        this.$$toast('请输入有效的手机号')
        return
      }
      // 查询逻辑
      this.$$loading(true)
      queryYueSaoOrder({ mobile: this.phone }).then((res) => {
        this.orderId = res.orderId || ''
        this.$$loading(false)
      }).catch((err) => {
        this.$$toast(err)
        this.$$loading(false)
      })

    },
    onBind() {
      if (!this.orderId) {
        this.$$toast('请先查询订单号')
        return
      }
      if (!this.babyGender) {
        this.$$toast('请选择宝宝性别')
        return
      }
      // 绑定订单逻辑
      this.$$loading(true)
      saveBindOrder({
        orderId: this.orderId,
        sex: this.babyGender === '男' ? 1 : 2
      }).then((res) => {
        this.$$loading(false)
        this.$$toast('绑定成功')
        this.$router.replace(`/yuesao-serve/log-detail-serve?orderId=${this.orderId}`)
      }).catch((err) => {
        this.$$loading(false)
        this.$$toast(err)
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.container {
  background-color: #f4f4f4;
}

.top-bg {
  position: fixed;
  width: 100%;
  height: rem(254px);
  mix-blend-mode: normal;
  border-radius: rem(8px);
  background: linear-gradient(305.29deg, #baf9fd 31.77%, #ffc8fd 74.99%, #ffdbf8 94.76%, #fff8d0 128.06%);
  filter: blur(50px);
}

.bind-order-card {
  position: relative;
  background: #fff;
  border-radius: rem(24px);
  padding: 0 rem(28px);
  margin: rem(24px);
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: rem(100px);
}

.line {
  height: 1px;
  width: rem(654px);
  height: 1px;
  mix-blend-mode: normal;
  background: #F2F2F2;
}

.label {
  color: #262626;
  font-size: rem(28px);
}

.value {
  text-align: right;
  color: #262626;
  font-size: rem(28px);
}

.value.gray {
  color: #AEAEAE;
}

.required {
  color: #FE0200;
}

.select {
  margin-left: rem(8px);
  padding: rem(4px) rem(8px);
  border-radius: rem(4px);
  border: 1px solid #eee;
  font-size: rem(15px);
  background: #fafafa;
}

.select-trigger {
  text-align: right;
  color: #999999;
  font-weight: 400;
  font-size: rem(28px);

  img {
    width: rem(10px);
    height: rem(17px);
    margin-left: rem(16px);
  }
}

.btn-group {
  display: flex;
  justify-content: space-between;
  margin: rem(60px) rem(28px);
}

.btn {
  width: rem(336px);
  height: rem(82px);
  mix-blend-mode: normal;
  border-radius: rem(40px);
}

.btn.gray {
  background: #fff;
  color: #2A2A2A;
  border: 1px solid #bebebe;
  font-weight: normal;
}

.btn.pink {
  background: linear-gradient(90deg, #fe397e 0%, #ff074c 100%);
  font-weight: bold;
  color: #fff;
}

/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #ff397e;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: rem(28px);
}

/deep/ .van-ellipsis {
  color: #262626;
  font-size: rem(36px);
}
</style>